import { defineMessages } from "react-intl";

export const messages = defineMessages({
  assignVariantDialogHeader: {
    id: "xAHOGV",
    defaultMessage: "Assign Variant",
    description: "dialog header",
  },
  assignVariantDialogButton: {
    id: "p4X/0H",
    defaultMessage: "Assign and save",
    description: "button, assign variants to sale and save",
  },
  assignVariantDialogContent: {
    id: "K+vjtE",
    defaultMessage: "Search Variants",
  },
  assignVariantDialogSearch: {
    id: "SHm7ee",
    defaultMessage: "Search by product name, attribute, product type etc...",
  },
  assignVariantDialogSKU: {
    id: "+HuipK",
    defaultMessage: "SKU {sku}",
    description: "variant sku",
  },
  noProductsInChannel: {
    id: "shmSDX",
    defaultMessage:
      "No products are available in the channel assigned to this order.",
    description: "no products placeholder",
  },
  noProductsInQuery: {
    id: "9mrWKz",
    defaultMessage:
      "No products are available matching query in the channel assigned to this order.",
    description: "no products placeholder",
  },
});
